import { memo } from 'react';
import type { SuperHeaderProps } from './SuperHeader.types';
import { useSuperHeader } from './useSuperHeader';

function SuperHeaderBase({ leading, breadcrumb, center, trailing, className }: SuperHeaderProps) {
  const vm = useSuperHeader();

  return (
    <header className={className} style={vm.headerStyle}>
      {leading && <div style={{ display: 'inline-flex', alignItems: 'center' }}>{leading}</div>}
      {breadcrumb && (
        <nav aria-label="Breadcrumb" style={vm.breadcrumbStyle}>
          {breadcrumb}
        </nav>
      )}
      {center && <div style={vm.centerStyle}>{center}</div>}
      {trailing && (
        <div style={{ display: 'inline-flex', alignItems: 'center', gap: 12 }}>{trailing}</div>
      )}
    </header>
  );
}

export const SuperHeader = memo(SuperHeaderBase);
